"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CommonSections = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _MessageStrip = _interopRequireDefault(require("@concur/nui-widgets/lib/MessageStrip/MessageStrip"));
var _SkipLink = _interopRequireDefault(require("@concur/nui-widgets/SkipLink"));
var _reactRedux = require("react-redux");
var _AppCategory = _interopRequireDefault(require("../listings/AppCategory"));
var _LoadingIndicator = _interopRequireDefault(require("./LoadingIndicator"));
var ListingsActions = _interopRequireWildcard(require("../listings/listingsModule"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// let SEED = Date.now();
// function random() {
//   const x = Math.sin(SEED++) * 10000;
//   return x - Math.floor(x);
// }
var CommonSections = exports.CommonSections = /*#__PURE__*/function (_React$Component) {
  function CommonSections() {
    var _this;
    _classCallCheck(this, CommonSections);
    _this = _callSuper(this, CommonSections);
    _this.state = {
      toDNFAdminHidden: false
    };
    _this.dismissToDNFAdmin = _this.dismissToDNFAdmin.bind(_this);
    return _this;
  }
  _inherits(CommonSections, _React$Component);
  return _createClass(CommonSections, [{
    key: "buildCollectionSet",
    value: function buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps) {
      var _this$props = this.props,
        listings = _this$props.listings,
        formatter = _this$props.formatter;
      var MIN_APP_NUM = 20;
      var MIN_NUM_LISTINGS = allListingsSection.length >= MIN_APP_NUM;
      var categoryDescription = listings.categoryFilter.length ? listings.categoryFilter[0].description : '';
      var enterpriseCategoryTitle = formatter.formattedMessage({
        id: 'EnterpriseAppsCollection',
        values: {
          category: categoryDescription
        }
      });
      var allCategoryTitle = formatter.formattedMessage({
        id: MIN_NUM_LISTINGS ? 'AllAppsCollection' : 'Connections'
      });
      if (!popularListings.length && !popularForEnterprise.length && !allListingsSection.length) {
        return this.renderNoResults();
      }

      // we don't want two collections showing the same listings
      if ((!popularListings.length || !popularForEnterprise.length) && popularListings.length < 10 && popularForEnterprise.length < 10) {
        // error without these being declared here
        var tempCatTitle;
        var tempCatSubtitle;
        var tempCatQuickHelpMessage;
        if (popularForEnterprise.length) {
          tempCatTitle = enterpriseCategoryTitle;
          tempCatSubtitle = 'EnterpriseAppsCollectionSubtitle';
          tempCatQuickHelpMessage = /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
            id: "EnterpriseAppsCollectionQuickHelpMessage"
          });
        } else {
          tempCatTitle = allCategoryTitle;
          tempCatSubtitle = 'AllAppsCollectionSubtitle';
        }
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "col-xs-12",
          id: "all-listings"
        }, /*#__PURE__*/_react.default.createElement(_AppCategory.default, {
          categoryTitle: tempCatTitle,
          categorySubtitle: /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
            id: tempCatSubtitle
          }),
          categoryQuickHelpMessage: tempCatQuickHelpMessage,
          listings: partitionedAllApps,
          isLoggedIn: this.props.userPrefs.isLoggedIn,
          windowWidth: window.innerWidth,
          betas: this.props.userBetas,
          dataTestId: "CommonSections-AppCategory-all-listings"
        })));
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "listings-section"
      }, MIN_NUM_LISTINGS && /*#__PURE__*/_react.default.createElement("div", {
        id: "popular-section",
        className: "row"
      }, /*#__PURE__*/_react.default.createElement(_SkipLink.default, {
        label: formatter.formattedMessage({
          id: 'SkipToEnterpriseApplications'
        }),
        url: "#popular-for-enterprise"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-collection"
      }, /*#__PURE__*/_react.default.createElement(_AppCategory.default, {
        categoryTitle: formatter.formattedMessage({
          id: 'PopularConnectionsCollection'
        }),
        categorySubtitle: /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "PopularConnsCollectionSubtitle"
        }),
        listings: popularListings,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth,
        betas: this.props.userBetas,
        dataTestId: "CommonSections-AppCategory-popular-section"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-for-enterprise"
      }, /*#__PURE__*/_react.default.createElement(_SkipLink.default, {
        label: formatter.formattedMessage({
          id: 'SkipToUserConnections'
        }),
        url: "#all-listings"
      }), /*#__PURE__*/_react.default.createElement(_AppCategory.default, {
        categoryTitle: enterpriseCategoryTitle,
        categorySubtitle: /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "EnterpriseAppsCollectionSubtitle"
        }),
        categoryQuickHelpMessage: /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "EnterpriseAppsCollectionQuickHelpMessage"
        }),
        listings: popularForEnterprise,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth,
        betas: this.props.userBetas
      }))), /*#__PURE__*/_react.default.createElement("div", {
        id: "connections-section",
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12",
        id: "all-listings"
      }, /*#__PURE__*/_react.default.createElement(_AppCategory.default, {
        categoryTitle: allCategoryTitle,
        categorySubtitle: /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "AllAppsCollectionSubtitle"
        }),
        listings: MIN_NUM_LISTINGS ? allListingsSection : nonshuffledAllListingsSection,
        isLoggedIn: this.props.userPrefs.isLoggedIn,
        windowWidth: window.innerWidth,
        betas: this.props.userBetas
      }))));
    }
  }, {
    key: "renderNoResults",
    value: function renderNoResults() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "col-xs-12",
        id: "popular-collection"
      }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "NoSearchResults"
      })));
    }
  }, {
    key: "dismissToDNFAdmin",
    value: function dismissToDNFAdmin() {
      this.setState({
        toDNFAdminHidden: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        overrideListings = _this$props2.overrideListings,
        isDnfPartnerAdmin = _this$props2.isDnfPartnerAdmin,
        _this$props2$listings = _this$props2.listings,
        listingsReadyState = _this$props2$listings.listingsReadyState,
        filteredListings = _this$props2$listings.filtered,
        formatter = _this$props2.formatter;
      // If overrideListings prop is provided, display those listings. If not,
      // display the filtered listings in the Redux store.
      var filtered = overrideListings || filteredListings;
      var isLoaded = listingsReadyState === ListingsActions.LISTINGS_FETCHED;
      if (listingsReadyState === ListingsActions.LISTINGS_FETCH_FAILED) {
        return /*#__PURE__*/_react.default.createElement("p", null, "Failed to fetch Listings");
      }
      function prioritySort(a, b) {
        if (a.core.priority < b.core.priority) {
          return -1;
        }
        if (a.core.priority > b.core.priority) {
          return 1;
        }
        return 0;
      }
      var partitionedListings = _lodash.default.partition(filtered.concat([]).sort(prioritySort), function (listing) {
        return !listing.core.listingDisabled;
      });
      var partitionedAllApps = _lodash.default.flatten(partitionedListings);
      var popularListings = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).take(10).value();
      var popularForEnterprise = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'ADMIN';
      }).sort(prioritySort).value();
      var shuffledPartionedAllApps = _lodash.default.shuffle(partitionedListings[0]).concat(_lodash.default.shuffle(partitionedListings[1]));
      var nonshuffledAllListingsSection = _lodash.default.chain(partitionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();
      var allListingsSection = _lodash.default.chain(shuffledPartionedAllApps).filter(function (listing) {
        return listing.core.clientOptInType === 'USER';
      }).value();
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          minHeight: '1151px'
        }
      }, /*#__PURE__*/_react.default.createElement(_LoadingIndicator.default, {
        isLoaded: isLoaded
      }, isDnfPartnerAdmin && !this.state.toDNFAdminHidden && /*#__PURE__*/_react.default.createElement("div", {
        className: "listings-row-responsive"
      }, /*#__PURE__*/_react.default.createElement(_MessageStrip.default, {
        typeLabel: formatter.formattedMessage({
          id: 'CoreUIComponents.info'
        }),
        message: /*#__PURE__*/_react.default.createElement("a", {
          href: "/nui/appcenteradmin/dnfs"
        }, ' ', /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
          id: "AppCenterV2.ToDNFAdmin"
        }), ' '),
        dismissible: {
          dismissLabel: formatter.formattedMessage({
            id: 'AppCenterV2.Dismiss'
          }),
          onDismiss: this.dismissToDNFAdmin
        },
        type: "info",
        style: {
          marginTop: '24px',
          marginBottom: '24px'
        }
      })), this.buildCollectionSet(popularListings, popularForEnterprise, allListingsSection, nonshuffledAllListingsSection, partitionedAllApps)));
    }
  }]);
}(_react.default.Component);
CommonSections.propTypes = {
  listings: _propTypes.default.object,
  overrideListings: _propTypes.default.arrayOf(_propTypes.default.object),
  isDnfPartnerAdmin: _propTypes.default.bool,
  userPrefs: _propTypes.default.shape({
    isLoggedIn: _propTypes.default.bool
  }),
  formatter: _propTypes.default.object
};
function mapStateToProps(state) {
  var _state$userProfile;
  return {
    listings: state.listings,
    user: state.user,
    isDnfPartnerAdmin: (_state$userProfile = state.userProfile) === null || _state$userProfile === void 0 ? void 0 : _state$userProfile.isDnfPartnerAdmin,
    userPrefs: state.userPrefs,
    userBetas: state.betas || {}
  };
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _nuiIntlRuntime.withFormatter)(CommonSections));